import {
  ConeAssetModelFormFields,
  ConeJSONFromFormFields,
  DomeAssetModelFormFields,
  DomeJSONFromFormFields,
  DomeWallAssetModelFormFields,
  DomeWallJSONFromFormFields,
  EllipsoidalHeadAssetModelFormFields,
  EllipsoidalHeadJSONFromFormFields,
  FlatCircularFloorAssetModelFormFields,
  FlatCircularFloorJSONFromFormFields,
  FormField,
  GeckoComponentModelJSON,
  GeckoComponentModelType,
  HemisphericalHeadAssetModelFormFields,
  HemisphericalHeadJSONFromFormFields,
  HoodBendAssetModelFormFields,
  HoodBendJSONFromFormFields,
  HoodStraightAssetModelFormFields,
  HoodStraightJSONFromFormFields,
  HorizontalTankShellAssetModelFormFields,
  HorizontalTankShellJSONFromFormFields,
  LaunchTubeAssetModelFormFields,
  LaunchTubeJSONFromFormFields,
  LegacyBoilerWallsAssetModelFormFields,
  LegacyBoilerWallsJSONFromFormFields,
  LegacyConeAssetModelFormFields,
  LegacyConeJSONFromFormFields,
  MachinedForgingSimpleAssetModelFormFields,
  MachinedForgingSimpleJSONFromFormFields,
  NewConeAssetModelJSON,
  NewDomeAssetModelJSON,
  NewDomeWallAssetModelJSON,
  NewEllipsoidalHeadAssetModelJSON,
  NewFlatCircularFloorAssetModelJSON,
  NewHemisphericalHeadAssetModelJSON,
  NewHoodBendAssetModelJSON,
  NewHoodStraightAssetModelJSON,
  NewHorizontalTankShellAssetModelJSON,
  NewLaunchTubeAssetModelJSON,
  NewLegacyBoilerWallsJSON,
  NewLegacyConeAssetModelJSON,
  NewMachinedForgingSimpleComponentJSON,
  NewPipeEccentricReducerAssetModelJSON,
  NewPipeElbowAssetModelJSON,
  NewPipeSectionAssetModelJSON,
  NewPipeTJointAssetModelJSON,
  NewPressureVesselShellAssetModelJSON,
  NewShipDeckAssetModelJSON,
  NewShipHullAssetModelJSON,
  NewSphereFlatCapAssetModelJSON,
  NewTankFlatRoofAssetModelJSON,
  NewTankFloorAssetModelJSON,
  NewTorisphericalHeadAssetModelJSON,
  NewVerticalTankFoundationComponentJSON,
  NewVerticalTankShellComponentJSON,
  PipeEccentricReducerFormFields,
  PipeEccentricReducerJSONFromFormFields,
  PipeElbowFormFields,
  PipeElbowJSONFromFormFields,
  PipeSectionAssetModelFormFields,
  PipeSectionJSONFromFormFields,
  PipeTJointFormFields,
  PipeTJointJSONFromFormFields,
  PressureVesselShellAssetModelFormFields,
  PressureVesselShellJSONFromFormFields,
  ShipDeckAssetModelFormFields,
  ShipDeckJSONFromFormFields,
  ShipHullAssetModelFormFields,
  ShipHullJSONFromFormFields,
  SphereFlatCapAssetModelFormFields,
  SphereFlatCapJSONFromFormFields,
  TankFloorAssetModelFormFields,
  TankFloorJSONFromFormFields,
  TankRoofAssetModelFormFields,
  TankRoofJSONFromFormFields,
  TorisphericalHeadAssetModelFormFields,
  TorisphericalHeadJSONFromFormFields,
  VerticalTankFoundationFormFields,
  VerticalTankFoundationJSONFromFormFields,
  VerticalTankShellAssetModelFormFields,
  VerticalTankShellJSONFromFormFields,
} from 'types'

export const getFormFieldsForComponentType = (
  component: GeckoComponentModelJSON
): FormField[] => {
  const componentType = component.type
  switch (componentType) {
    case GeckoComponentModelType.VerticalTankShell:
      return VerticalTankShellAssetModelFormFields(component)
    case GeckoComponentModelType.TankFloor:
      return TankFloorAssetModelFormFields(component)
    case GeckoComponentModelType.TankFlatRoof:
      return TankRoofAssetModelFormFields(component)
    case GeckoComponentModelType.HorizontalTankShell:
      return HorizontalTankShellAssetModelFormFields(component)
    case GeckoComponentModelType.PipeSection:
      return PipeSectionAssetModelFormFields(component)
    case GeckoComponentModelType.LegacyBoilerWalls:
      return LegacyBoilerWallsAssetModelFormFields(component)
    case GeckoComponentModelType.ShipDeck:
      return ShipDeckAssetModelFormFields(component)
    case GeckoComponentModelType.BasicShipHull:
      return ShipHullAssetModelFormFields(component)
    case GeckoComponentModelType.LegacyCone:
      return LegacyConeAssetModelFormFields(component)
    case GeckoComponentModelType.Cone:
      return ConeAssetModelFormFields(component)
    case GeckoComponentModelType.LaunchTube:
      return LaunchTubeAssetModelFormFields(component)
    case GeckoComponentModelType.Dome:
      return DomeAssetModelFormFields(component)
    case GeckoComponentModelType.DomeWall:
      return DomeWallAssetModelFormFields(component)
    case GeckoComponentModelType.FlatCircularFloor:
      return FlatCircularFloorAssetModelFormFields(component)
    case GeckoComponentModelType.VerticalTankFoundation:
      return VerticalTankFoundationFormFields(component)
    case GeckoComponentModelType.PipeElbow:
      return PipeElbowFormFields(component)
    case GeckoComponentModelType.PipeTJoint:
      return PipeTJointFormFields(component)
    case GeckoComponentModelType.PipeEccentricReducer:
      return PipeEccentricReducerFormFields(component)
    case GeckoComponentModelType.MachinedForgingSimple:
      return MachinedForgingSimpleAssetModelFormFields(component)
    case GeckoComponentModelType.HemisphericalHead:
      return HemisphericalHeadAssetModelFormFields(component)
    case GeckoComponentModelType.TorisphericalHead:
      return TorisphericalHeadAssetModelFormFields(component)
    case GeckoComponentModelType.EllipsoidalHead:
      return EllipsoidalHeadAssetModelFormFields(component)
    case GeckoComponentModelType.PressureVesselShell:
      return PressureVesselShellAssetModelFormFields(component)
    case GeckoComponentModelType.SphereFlatCap:
      return SphereFlatCapAssetModelFormFields(component)
    case GeckoComponentModelType.HoodStraight:
      return HoodStraightAssetModelFormFields(component)
    case GeckoComponentModelType.HoodBend:
      return HoodBendAssetModelFormFields(component)
  }
}

export const getJSONFromComponentFormFields = (
  component: GeckoComponentModelJSON,
  formFields: FormField[]
): GeckoComponentModelJSON => {
  const componentType = component.type
  switch (componentType) {
    case GeckoComponentModelType.VerticalTankShell: {
      return VerticalTankShellJSONFromFormFields(component, formFields)
    }
    case GeckoComponentModelType.TankFloor: {
      return TankFloorJSONFromFormFields(component, formFields)
    }
    case GeckoComponentModelType.TankFlatRoof: {
      return TankRoofJSONFromFormFields(component, formFields)
    }
    case GeckoComponentModelType.HorizontalTankShell: {
      return HorizontalTankShellJSONFromFormFields(component, formFields)
    }
    case GeckoComponentModelType.PipeSection: {
      return PipeSectionJSONFromFormFields(component, formFields)
    }
    case GeckoComponentModelType.LegacyBoilerWalls: {
      return LegacyBoilerWallsJSONFromFormFields(component, formFields)
    }
    case GeckoComponentModelType.ShipDeck: {
      return ShipDeckJSONFromFormFields(component, formFields)
    }
    case GeckoComponentModelType.BasicShipHull: {
      return ShipHullJSONFromFormFields(component, formFields)
    }
    case GeckoComponentModelType.LegacyCone: {
      return LegacyConeJSONFromFormFields(component, formFields)
    }
    case GeckoComponentModelType.Cone: {
      return ConeJSONFromFormFields(component, formFields)
    }
    case GeckoComponentModelType.LaunchTube: {
      return LaunchTubeJSONFromFormFields(component, formFields)
    }
    case GeckoComponentModelType.Dome: {
      return DomeJSONFromFormFields(component, formFields)
    }
    case GeckoComponentModelType.DomeWall: {
      return DomeWallJSONFromFormFields(component, formFields)
    }
    case GeckoComponentModelType.FlatCircularFloor: {
      return FlatCircularFloorJSONFromFormFields(component, formFields)
    }
    case GeckoComponentModelType.VerticalTankFoundation: {
      return VerticalTankFoundationJSONFromFormFields(component, formFields)
    }
    case GeckoComponentModelType.PipeElbow: {
      return PipeElbowJSONFromFormFields(component, formFields)
    }
    case GeckoComponentModelType.PipeTJoint: {
      return PipeTJointJSONFromFormFields(component, formFields)
    }
    case GeckoComponentModelType.PipeEccentricReducer: {
      return PipeEccentricReducerJSONFromFormFields(component, formFields)
    }
    case GeckoComponentModelType.MachinedForgingSimple: {
      return MachinedForgingSimpleJSONFromFormFields(component, formFields)
    }
    case GeckoComponentModelType.HemisphericalHead: {
      return HemisphericalHeadJSONFromFormFields(component, formFields)
    }
    case GeckoComponentModelType.TorisphericalHead: {
      return TorisphericalHeadJSONFromFormFields(component, formFields)
    }
    case GeckoComponentModelType.EllipsoidalHead: {
      return EllipsoidalHeadJSONFromFormFields(component, formFields)
    }
    case GeckoComponentModelType.PressureVesselShell: {
      return PressureVesselShellJSONFromFormFields(component, formFields)
    }
    case GeckoComponentModelType.SphereFlatCap: {
      return SphereFlatCapJSONFromFormFields(component, formFields)
    }
    case GeckoComponentModelType.HoodStraight: {
      return HoodStraightJSONFromFormFields(component, formFields)
    }
    case GeckoComponentModelType.HoodBend: {
      return HoodBendJSONFromFormFields(component, formFields)
    }
  }
}

export const getNewJSONForComponentType = (
  componentType: GeckoComponentModelType,
  componentName: string
): GeckoComponentModelJSON => {
  switch (componentType) {
    case GeckoComponentModelType.VerticalTankShell:
      return { ...NewVerticalTankShellComponentJSON, name: componentName }
    case GeckoComponentModelType.TankFloor:
      return { ...NewTankFloorAssetModelJSON, name: componentName }
    case GeckoComponentModelType.TankFlatRoof:
      return { ...NewTankFlatRoofAssetModelJSON, name: componentName }
    case GeckoComponentModelType.HorizontalTankShell:
      return { ...NewHorizontalTankShellAssetModelJSON, name: componentName }
    case GeckoComponentModelType.PipeSection:
      return { ...NewPipeSectionAssetModelJSON, name: componentName }
    case GeckoComponentModelType.LegacyBoilerWalls:
      return { ...NewLegacyBoilerWallsJSON, name: componentName }
    case GeckoComponentModelType.ShipDeck:
      return { ...NewShipDeckAssetModelJSON, name: componentName }
    case GeckoComponentModelType.BasicShipHull:
      return { ...NewShipHullAssetModelJSON, name: componentName }
    case GeckoComponentModelType.LegacyCone:
      return { ...NewLegacyConeAssetModelJSON, name: componentName }
    case GeckoComponentModelType.Cone:
      return { ...NewConeAssetModelJSON, name: componentName }
    case GeckoComponentModelType.LaunchTube:
      return { ...NewLaunchTubeAssetModelJSON, name: componentName }
    case GeckoComponentModelType.Dome:
      return { ...NewDomeAssetModelJSON, name: componentName }
    case GeckoComponentModelType.DomeWall:
      return { ...NewDomeWallAssetModelJSON, name: componentName }
    case GeckoComponentModelType.FlatCircularFloor:
      return { ...NewFlatCircularFloorAssetModelJSON, name: componentName }
    case GeckoComponentModelType.VerticalTankFoundation:
      return { ...NewVerticalTankFoundationComponentJSON, name: componentName }
    case GeckoComponentModelType.PipeElbow:
      return { ...NewPipeElbowAssetModelJSON, name: componentName }
    case GeckoComponentModelType.PipeTJoint:
      return { ...NewPipeTJointAssetModelJSON, name: componentName }
    case GeckoComponentModelType.PipeEccentricReducer:
      return { ...NewPipeEccentricReducerAssetModelJSON, name: componentName }
    case GeckoComponentModelType.MachinedForgingSimple:
      return { ...NewMachinedForgingSimpleComponentJSON, name: componentName }
    case GeckoComponentModelType.HemisphericalHead:
      return { ...NewHemisphericalHeadAssetModelJSON, name: componentName }
    case GeckoComponentModelType.TorisphericalHead:
      return { ...NewTorisphericalHeadAssetModelJSON, name: componentName }
    case GeckoComponentModelType.EllipsoidalHead:
      return { ...NewEllipsoidalHeadAssetModelJSON, name: componentName }
    case GeckoComponentModelType.PressureVesselShell:
      return { ...NewPressureVesselShellAssetModelJSON, name: componentName }
    case GeckoComponentModelType.SphereFlatCap:
      return { ...NewSphereFlatCapAssetModelJSON, name: componentName }
    case GeckoComponentModelType.HoodStraight:
      return { ...NewHoodStraightAssetModelJSON, name: componentName }
    case GeckoComponentModelType.HoodBend:
      return { ...NewHoodBendAssetModelJSON, name: componentName }
  }
}
